export default __webpack_public_path__ + "static/homefront-0dc0cb7f14e5311d3d449897faccb4c8.png";